import { isReportCompleted } from "@utils/reportStatus";

import { ReportSection } from "@components/ReportField/ReportSection";
import { AddSection } from "@pages/EvaluationDetails/Components/AddSection";
import {
  FilterSectionSubRoute,
  useGetFilteredPageSectionsByLocation,
} from "@pages/EvaluationDetails/Components/helper";
import { FooterButtonRow } from "@pages/EvaluationDetails/EvaluationDetailsSubPages/FooterButtonRow";
import { StickyNav } from "@pages/EvaluationDetails/EvaluationDetailsSubPages/StickyNav/StickyNav";
import { useAdminData } from "@providers/AdminDataProvider";
import { useReport } from "@providers/ReportProvider";

const pageLocation: FilterSectionSubRoute = "recommendations";

export const EvaluationRecommendations: React.FC = () => {
  const filteredSections = useGetFilteredPageSectionsByLocation(pageLocation);
  const { report } = useReport();
  const reportIsCompleted = isReportCompleted(report);

  const { isCatalightUser, isAT4KUser } = useAdminData();
  const canAddSection = !isAT4KUser && !isCatalightUser;

  return (
    <div className="flex w-full flex-col pb-6">
      <div className="grid grid-cols-4 gap-x-1">
        <div className={`col-span-3 flex w-full flex-col gap-y-4`}>
          {canAddSection && !filteredSections[0] && (
            <AddSection newRankOrder={1} defaultNewSectionTitle="Enter Section Title" pageLocation={pageLocation} />
          )}
          {filteredSections.map((section) => (
            <ReportSection key={section.id} section={section} disabled={reportIsCompleted} />
          ))}
        </div>

        <div className="flex w-full flex-col pl-8">
          <StickyNav state={filteredSections} />
        </div>
      </div>
      <FooterButtonRow primaryButtonTitle={"Next"} />
    </div>
  );
};
